import React,{useEffect, useState} from 'react';

import { useDispatch, useSelector } from "react-redux";
import { createAction } from 'redux-actions';

import { List, ListItem, Collapse, IconButton, Chip, Box } from '@material-ui/core';

import { Link } from 'react-router-dom';

import classNames from 'classnames';

import IconKeyboardArrowDown from '@material-ui/icons/KeyboardArrowDown';

import IconKeyboardArrowUp from '@material-ui/icons/KeyboardArrowUp';

import IconMinus from '@material-ui/icons/Minimize';

import isActive from '../../../../../helpers/routeHelper';

import { ACTIVATE_TOOLTIP, DEACTIVATE_TOOLTIP, HIDE_COMPOSE_SUB_MENU } from '../../../../../constants/actionTypes';

import useStyles from '../../styles/sideMenu.styles';

import './menuTooltip.css'


const MenuItem = ({ item, isMenuOpen, isDisabled }) => {
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = React.useState(false);
  {/* const [showComposeTooltip, setShowComposeTooltip] = React.useState(false); */}
  const tillCreatedPost = useSelector(state => state?.currentUser?.user?.user_created_post);
  const haveBrands = useSelector(state => state?.brandsList?.data);
  const allChannels = useSelector((state) => {
    const socialAccounts = state?.entities?.socialAccounts;
    const brands = state?.entities?.brand || [];
    return Object.values(socialAccounts).map(account => {
        const { id, username, brandId, socialPlatform: { id: socialPlatformId } } = account;
        const brand = Object.values(brands).find(brand => parseInt(brand.id) === parseInt(brandId)) || {};
        const { name: brandName, media_url: brandImageSrc } = brand;
        return {
            brandName,
            brandImageSrc,
            brandId,
            id,
            name: username,
            socialPlatformId
        }
    }).filter(item => !!item.brandName)
        .sort((account1, account2) => {
            if (account1.brandName < account2.brandName) {
                return -1
            } else {
                return 1
            }
        })
  });
  const showComposeTooltip = useSelector(state => state?.tooltip?.isActive)
  const isComposeSubMenuOpen = useSelector(state => state?.tooltip?.isOpen)
  const isTooltipActive = useSelector(state => state?.currentUser?.user?.tooltip);

  const { label, link, renderIcon, children, comingSoon } = item;

  const styles = useStyles();

  const itemClasses = classNames({
    [styles.menuItem]: true,
    [styles.menuItemClosed]: !isMenuOpen,
    [styles.activeMenuItem]: isActive(link)
  });

  const handleClick = () => {
    setIsOpen(!isOpen);
  };

  const isChildLinkActive = itm => itm.children.some(child => isActive(child.link));

  const handleHideComposeTooltip = () => {
    const deactivateTooltip = createAction(DEACTIVATE_TOOLTIP);
    dispatch(deactivateTooltip())
  }

  useEffect(() =>{
    if(isTooltipActive && haveBrands?.length > 0 && allChannels?.length > 0){
      const activeTooltip = createAction(ACTIVATE_TOOLTIP);
      dispatch(activeTooltip());
      setIsOpen(true);
    } else {
      handleHideComposeTooltip()
    }
  },[])

  useEffect(() => {
    if ((isTooltipActive && haveBrands?.length > 0 && allChannels?.length > 0) && isComposeSubMenuOpen) {
      setIsOpen(true)
      const hideComposeTooltip = createAction(HIDE_COMPOSE_SUB_MENU);
      dispatch(hideComposeTooltip())
    }
  }, [isComposeSubMenuOpen])

  if (children && isMenuOpen) {
    return (
      <ListItem className={classNames({
        [styles.menuItem]: true,
        [styles.menuItemClosed]: !isMenuOpen
      })}
      >
        <div className={styles.menuItemBox}>
          <Link to={link}>
            <div className={styles.menuItemBox}>
              {renderIcon(isChildLinkActive(item))}
              <span>{label}</span>
              <div>
                {comingSoon &&
                  <Chip size="small" label="Coming Soon" />}
              </div>
            </div>
          </Link>
          <IconButton disableRipple onClick={handleClick}>
            {(isOpen || isComposeSubMenuOpen) ? <IconKeyboardArrowUp /> : <IconKeyboardArrowDown />}
          </IconButton>
        </div >
        <Collapse in={isOpen || isComposeSubMenuOpen}>
          <List>
            {children.map((child, index) => {
              const { link: childLink, name, label: childLabel } = child;
              const innerItemClasses = classNames({
                [styles.innerMenuItem]: true,
                [styles.activeMenuItem]: isActive(childLink)
              });
              return (
                <ListItem key={name} className={innerItemClasses}>
                  <Link to={childLink} id={`publishSubList${index}`} className={`${(isTooltipActive && showComposeTooltip && (childLabel == 'Compose' || childLabel == 'Scheduler')) ? 'publishSubList publishSubList2':''}`} onClick={handleHideComposeTooltip} >
                    <IconMinus />
                    <span>{childLabel}</span>
                  </Link>
                  {/* compose tooltip start*/}
                  {(isTooltipActive && showComposeTooltip && childLabel == 'Compose') && (
                  <><div className='publishTooltip composeTooltip'>
                      <h4>Compose</h4>
                      <small className='tooltipDesc'>Create your post here</small>
                  </div>
                  <div className='publishHorizontalLine composeHorizontaleDotline'></div></>
                  )}
                  {/* compose tooltip end*/}


                  {/* schedule tooltip start */}
                  {(isTooltipActive && showComposeTooltip && childLabel == 'Scheduler') && (<>
                  <div className='publishTooltip schedularTooltip '>
                      <h4>View schedule</h4>
                      <small className='tooltipDesc'>Click to view a calendar of posts</small>
                  </div>
                  <div className='schedularHorizontaleDotline'></div></>
                  )}
                  {/* schedule tooltip end */}
                </ListItem>
              );
            })}
          </List>
        </Collapse>
        {(isTooltipActive && showComposeTooltip) && (<div className='publishMenuBackground'></div>)}
      </ListItem >
    );
  }

  if (isDisabled) {
    return (
      <ListItem className={itemClasses}>
        <div className={styles.menuItemBox}>
          <Box style={{ opacity: 0.5 }} display="flex" alignItems="center" gridGap="16px">
            {renderIcon(isActive(link))}
            {isMenuOpen && <span>{label}</span>}
          </Box>
          {comingSoon &&
            <Chip size="small" label="Coming Soon" />}
        </div>
      </ListItem>
    );
  }

  return (
    <ListItem className={itemClasses}>
      <Link to={link}>
        <div className={styles.menuItemBox}>
          {renderIcon(isActive(link))}
          {isMenuOpen && <span>{label}</span>}
          {comingSoon &&
            <Chip size="small" label="Beta" />}
        </div>
      </Link>
    </ListItem>
  );
};


export default MenuItem;
